import React from "react";
import { bkNavegacion, clBasic } from "./general";

export default function Menu2Nivel({ children }) {
  return <div style={Smenu2}>{children}</div>;
}

const Smenu2 = {
  background: bkNavegacion,
  color: clBasic,
  minWidth: "3.3%",
  borderRight: "thin solid #E6E6E6",
  display: "flex",
  flexDirection: "column",
};
